import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { FindingView } from "../../findings/FindingView";
import type { Finding, FindingCode } from "../../model/Finding";

const EMPTY = msg({
  id: "analysis.section.empty",
  message: "No mistakes found here in this match.",
});

type OtherFindingsProps = {
  findings: readonly Finding[];
  // Коды, которые секция уже показала своим видом (таймлайном, карточками).
  shown?: readonly FindingCode[];
  // Секция что-то показала сама: «ошибок не найдено» не нужно.
  hasContent?: boolean;
};

// Находки секции, которые она не показала своим видом, — карточками из реестра. Так новый
// код находки виден на экране сразу, ещё до своей визуализации.
export const OtherFindings = ({ findings, shown = [], hasContent = false }: OtherFindingsProps) => {
  const { _ } = useLingui();
  const rest = findings.filter((finding) => !shown.includes(finding.code));
  if (rest.length === 0) {
    return hasContent ? null : <p className="text-sm text-muted">{_(EMPTY)}</p>;
  }
  return (
    <ul className="flex flex-col gap-2.5">
      {rest.map((finding, index) => (
        // Находки разбора не меняются после `done` — индекс как ключ безопасен.
        <li key={index}>
          <FindingView finding={finding} />
        </li>
      ))}
    </ul>
  );
};
